export const mapDbbEnvironmentToFlags = (
  tool: Record<string, any>,
): Record<string, any> => {
  if (tool?.dbbEnvironment === undefined) {
    return tool;
  }
  const { dbbEnvironment, ...rest } = tool;
  return {
    ...rest,
    isDbb: dbbEnvironment === "Production",
    isNonProdDbb: dbbEnvironment === "NonProduction",
  };
};
